import { styled } from '@mui/material/styles';
import { getAgentStatusColor } from '../../../helpers/agentHelper';
import { AgentStatus } from '../../../interfaces/Agent';

type StyledAgentStatus = {
  statusColor: AgentStatus;
};

const StyledAgentStatus = styled('div')<StyledAgentStatus>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  color: ${({ statusColor }) => getAgentStatusColor(statusColor)};
`;

export default StyledAgentStatus;
